import { __extends, __rest, __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-input.css';
import { UitkInput } from './uitk-input.esm.js';
var getClassNameList = classNames.bind(styles);
var RenderInformativeTrigger = function (props) {
  var trigger = props.trigger,
    a11yLabel = props.a11yLabel;
  var childrenArray = React.Children.toArray(trigger);
  var firstChild = childrenArray[0];
  var triggerClassName = '';
  if (firstChild.props.className) {
    triggerClassName = firstChild.props.className;
  }
  var triggerClassNames = getClassNameList('uitk-informative-input-trigger', 'uitk-input-cta', triggerClassName);
  return React.createElement(React.Fragment, null, React.cloneElement(trigger, {
    'aria-label': a11yLabel,
    className: triggerClassNames
  }, React.createElement(UitkIcon, {
    name: "info_outline",
    size: UitkIconSize.SMALL
  })));
};
var InformativeInput = /** @class */function (_super) {
  __extends(InformativeInput, _super);
  function InformativeInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InformativeInput.prototype.render = function () {
    var _a = this.props,
      informativeTrigger = _a.informativeTrigger,
      a11yInformativeTrigger = _a.a11yInformativeTrigger,
      childProps = __rest(_a, ["informativeTrigger", "a11yInformativeTrigger"]);
    return React.createElement(UitkInput, __assign({}, childProps, {
      className: getClassNameList('has-input-cta'),
      type: "text"
    }), React.createElement(RenderInformativeTrigger, {
      trigger: informativeTrigger,
      a11yLabel: a11yInformativeTrigger
    }));
  };
  return InformativeInput;
}(React.Component);
var UitkInformativeInput = function (props) {
  var l10n = useLocalization();
  return React.createElement(InformativeInput, __assign({
    l10n: l10n
  }, props));
};
export { RenderInformativeTrigger, UitkInformativeInput };